import { PermitFieldType } from '~/client/graph'
import { ResourceTypeId } from '~/client/src/shared/constants/resourceTypes'

const FIELD_TYPE_TO_RESOURCE: Partial<Record<PermitFieldType, string>> = {
  [PermitFieldType.Equipment]: ResourceTypeId.OFFLOADING_EQUIPMENT,
  [PermitFieldType.EquipmentInformational]: ResourceTypeId.OFFLOADING_EQUIPMENT,
  [PermitFieldType.MaterialResource]: ResourceTypeId.MATERIALS,
  [PermitFieldType.MaterialResourceInformational]: ResourceTypeId.MATERIALS,
  [PermitFieldType.Location]: ResourceTypeId.LOCATIONS,
  [PermitFieldType.LocationInformational]: ResourceTypeId.LOCATIONS,
}

export function getResourceTypeIdForFieldType(
  fieldType: PermitFieldType,
): string | null {
  return FIELD_TYPE_TO_RESOURCE[fieldType] ?? null
}
